import { useNavigate, useLocation } from "react-router-dom";

const snsLinks = [
  {
    icon: "ri-twitter-x-line",
    label: "メイン",
    url: "https://x.com/mazo_kawaii",
    bg: "bg-stone-700",
  },
  {
    icon: "ri-twitter-x-line",
    label: "サブ",
    url: "https://x.com/mazo_kawaii2",
    bg: "bg-amber-800/60",
  },
  {
    icon: "ri-article-line",
    label: "Blog",
    url: "https://muginox.hatenablog.com/",
    bg: "bg-rose-900/60",
    internal: false,
  },
];

export default function FooterSection() {
  const navigate = useNavigate();
  const location = useLocation();

  const isMobile = () => window.innerWidth < 768;

  const handleBlog = () => {
    navigate("/blog");
  };

  const handleBooking = () => {
    if (location.pathname === "/contact") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (isMobile() && location.pathname === "/") {
      const el = document.getElementById("contact");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    navigate("/contact");
  };


  return (
    <footer className="bg-stone-800 py-10 md:py-14 px-5 md:px-10">
      <div className="max-w-5xl mx-auto">

        {/* スマホ専用：SNS + 予約ボタン */}
        <div className="block md:hidden mb-8">

          {/* SNSリンク */}
          <div className="flex items-stretch gap-2 mb-3">
            {snsLinks.map((sns) => (
              sns.internal ? (
                <button
                  key={sns.url}
                  onClick={handleBlog}
                  className={`flex-1 flex flex-col items-center gap-2 py-4 ${sns.bg} hover:opacity-80 active:opacity-70 transition-opacity cursor-pointer rounded-sm border-none`}
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${sns.icon} text-white text-base`}></i>
                  </div>
                  <span className="text-xs text-stone-300 tracking-widest">{sns.label}</span>
                </button>
              ) : (
                <a
                  key={sns.url}
                  href={sns.url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className={`flex-1 flex flex-col items-center gap-2 py-4 ${sns.bg} hover:opacity-80 active:opacity-70 transition-opacity cursor-pointer rounded-sm`}
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${sns.icon} text-white text-base`}></i>
                  </div>
                  <span className="text-xs text-stone-300 tracking-widest">{sns.label}</span>
                </a>
              )
            ))}
          </div>

          {/* lit.link */}
          <a
            href="https://lit.link/hatomugicha91"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center justify-center gap-2 py-3.5 border border-stone-600 text-stone-400 text-xs tracking-[0.25em] hover:border-stone-400 hover:text-stone-300 active:opacity-70 transition-colors cursor-pointer rounded-sm"
          >
            <i className="ri-links-line text-sm"></i>
            スケジュール・リンク一覧
          </a>
        </div>

        {/* PC専用：SNS + ボタン群 */}
        <div className="hidden md:flex flex-col items-center gap-6 mb-10">

          {/* SNSリンク */}
          <div className="flex items-center gap-3">
            {snsLinks.map((sns) => (
              sns.internal ? (
                <button
                  key={sns.url}
                  onClick={handleBlog}
                  className={`flex items-center gap-2 px-5 py-2.5 ${sns.bg} hover:opacity-80 transition-opacity cursor-pointer rounded-sm border-none`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${sns.icon} text-white text-sm`}></i>
                  </div>
                  <span className="text-xs text-stone-300 tracking-widest whitespace-nowrap">{sns.label}</span>
                </button>
              ) : (
                <a
                  key={sns.url}
                  href={sns.url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className={`flex items-center gap-2 px-5 py-2.5 ${sns.bg} hover:opacity-80 transition-opacity cursor-pointer rounded-sm`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${sns.icon} text-white text-sm`}></i>
                  </div>
                  <span className="text-xs text-stone-300 tracking-widest whitespace-nowrap">{sns.label}</span>
                </a>
              )
            ))}
            <a
              href="https://lit.link/hatomugicha91"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-2 px-5 py-2.5 border border-stone-600 text-stone-400 text-xs tracking-[0.25em] hover:border-stone-400 hover:text-stone-300 transition-colors cursor-pointer rounded-sm whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-links-line text-sm"></i>
              </div>
              リンク一覧
            </a>
          </div>

        </div>

        {/* 共通：タイトル */}
        <div className="text-center mb-6 md:mb-8">
          <p
            className="font-en text-xl md:text-2xl font-light tracking-widest text-white mb-2"
          >
            Mugi Cha Production
          </p>
          <p
            className="font-en text-sm text-amber-400 tracking-widest italic mb-6"
          >
            Only for You – Private Release Session
          </p>

          {/* 予約ボタン */}
          <button
            onClick={handleBooking}
            className="inline-flex items-center gap-2.5 px-8 py-3.5 bg-amber-700 hover:bg-amber-600 active:bg-amber-800 transition-colors cursor-pointer rounded-full whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-check-line text-white text-sm"></i>
            </div>
            <span className="text-sm text-white tracking-[0.2em]">ご予約はこちら</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white/70 text-sm"></i>
            </div>
          </button>
        </div>

        <div className="w-full h-px bg-stone-600 mb-5"></div>

        {/* 営業エリア */}
        <div className="flex items-center justify-center mb-5">
          <div className="text-center">
            <p className="text-xs text-stone-500 tracking-widest mb-1.5">SERVICE AREA</p>
            <p className="text-sm text-stone-300 tracking-[0.3em] font-light">東京 / TOKYO</p>
            <p className="text-xs text-stone-500 tracking-wider mt-1">出張エリア：東京都内・近郊（要相談）</p>
          </div>
        </div>

        <div className="w-full h-px bg-stone-700 mb-5"></div>

        {/* コピーライト */}
        <div className="text-center space-y-1.5">
          <p className="text-xs text-stone-500 tracking-wider leading-relaxed">
            © 2024 Mugi Cha Production. All rights reserved.
          </p>
          <p className="text-xs text-stone-500 tracking-wider">
            18歳未満の方のご利用はお断りしております。
          </p>
          <p className="text-xs text-stone-400 tracking-widest font-medium">
            無店舗型性風俗特殊営業届出済
          </p>
        </div>

      </div>
    </footer>
  );
}
